document.addEventListener('DOMContentLoaded', function () {
  let overlay = document.querySelector('.see-similar-modal-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'see-similar-modal-overlay';
    overlay.innerHTML = `
      <div class="see-similar-modal">
        <button class="see-similar-modal-close" aria-label="Close">&times;</button>
        <h3>Similar Products</h3>
        <div class="see-similar-grid"><p>Loading...</p></div>
      </div>`;
    document.body.appendChild(overlay);
  }

  const grid = overlay.querySelector('.see-similar-grid');
  const closeModal = () => overlay.classList.remove('active');

  overlay.querySelector('.see-similar-modal-close').addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });

  let loaded = false;

  // Event delegation: works for ALL badges, even duplicated/cloned ones
  document.addEventListener('click', function (e) {
    const badge = e.target.closest('.see-similar-badge');
    if (!badge) return;

    overlay.classList.add('active');
    if (loaded) return;
    loaded = true;

    const productId = badge.dataset.productId;
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related')
      .then((res) => res.json())
      .then((data) => {
        if (!data.products || !data.products.length) {
          grid.innerHTML = '<p>No similar products found.</p>';
          return;
        }
        grid.innerHTML = data.products.map(function (p) {
          return '<a href="' + p.url + '" class="see-similar-item">' +
            '<img src="' + p.featured_image + '" alt="' + p.title + '" loading="lazy">' +
            '<div class="see-similar-item-title">' + p.title + '</div>' +
            '<div class="see-similar-item-price">₹' + (p.price / 100).toLocaleString('en-IN') + '</div>' +
            '</a>';
        }).join('');
      })
      .catch(function () {
        grid.innerHTML = '<p>Unable to load similar products right now.</p>';
      });
  });
});